import { useMutation } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';
import { Gender } from './useLongevityAnalysisQuery';

interface Params {
  principalGender: Gender;
  spouseGender: Gender;
  clientId: number;
  fpId: string | null;
}

const saveGender = ({ principalGender, spouseGender, clientId, fpId }: Params): Promise<null> => {
  return authFetch('/Consumer/GenderUpdate/PostLongevityAnalysisGenders', {
    method: 'POST',
    ...httpBodyOptions({
      principalGender,
      spouseGender,
      clientId,
      fpId,
    }),
  });
};

export const useLongevityAnalysisGenderMutation = () => {
  return useMutation(saveGender);
};
